import { render, staticRenderFns } from "./CouponPage.vue?vue&type=template&id=172a6bf9&scoped=true&"
import script from "./CouponPage.vue?vue&type=script&lang=ts&"
export * from "./CouponPage.vue?vue&type=script&lang=ts&"
import style0 from "./CouponPage.vue?vue&type=style&index=0&id=172a6bf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a6bf9",
  null
  
)

export default component.exports